import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixSendIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M6.90955 12.1094L11.8783 12.1094M6.75866 11.5272L2.96926 4.70832C2.39674 3.6781 3.4992 2.527 4.55362 3.05406L20.5247 11.0372C21.4084 11.479 21.4084 12.7398 20.5247 13.1815L4.55362 21.1647C3.49919 21.6918 2.39674 20.5407 2.96925 19.5104L6.75866 12.6915C6.95985 12.3295 6.95985 11.8893 6.75866 11.5272Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
    </SvgIcon>
  );
}
